import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@morpho-org/ui-v6/client';
import { TruncatedTooltip } from '@repo/ui';
interface RecapVaultHeaderProps {
  image: string | null | undefined;
  name: string;
}
const RecapVaultHeader = t0 => {
  const $ = _c(10);
  const {
    image,
    name
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = <Avatar src={image} size={24} padding={2} />;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== name) {
    t2 = ref => <span ref={ref} className="text-title-xs text-foreground truncate" style={{
      lineHeight: "normal"
    }}>{name}</span>;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== name || $[5] !== t2) {
    t3 = <TruncatedTooltip text={name}>{t2}</TruncatedTooltip>;
    $[4] = name;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className="gap-xs flex items-center">{t1}{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default RecapVaultHeader;